<template>
    <div id="app">
        <section class="shop" id="productstop">
            <div class="container">
                <div class="row">
                    <div class="col-xl-3 col-lg-4 col-12">
                        <span class="filterbtn d-block d-lg-none d-xl-none collapse" data-target="#sidebar-filter" data-toggle="collapse">Filter <span class="filterknop"></span></span>
                        <div class="sidebar-filter mt-50 collapse" id="sidebar-filter">
                            <div class="common-filter" id="accordion">
                                <CategorieLinks />
                                <ProductFilter />
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-9 col-lg-8 col-12">
                        <section class="latest-product-area pb-40 category-list">
                            <Products />
                        </section>
                        <div class="filter-bar d-flex flex-wrap align-items-center">
                            <Pagination :maxVisibleButtons="6" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
	import CategorieLinks from './components/CategorieLinks.vue'
	import ProductFilter from './components/ProductFilter.vue'
	import Pagination from './components/Pagination.vue'
	import Products from './components/Products.vue'

	export default {
    name: 'app',
        components: {
            CategorieLinks,
            ProductFilter,
            Pagination,
            Products
        }
    }
</script>
